"use client";
import { Fragment } from "react";
import BrushIcon from "@/assets/icons/brush.svg";
import CheckIcon from "@/assets/icons/checkmark-thin.svg";
import { Popover, Transition } from "@headlessui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import openToWorkApi from "@/api/art-order/openToWork/client";

export interface Props {
  userDisplayName: string;
  artistId: string;
  isOpenToWork?: boolean;
  className?: string;
  isArtistMe?: boolean;
}

const OpenToButton = ({ userDisplayName, isOpenToWork }: Props) => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateOpenToWorkStatus } = useMutation({
    mutationFn: (openToWork: boolean) =>
      openToWorkApi.openToWorkStatusChange(openToWork),
    onSuccess: () => {
      queryClient.invalidateQueries(["user", `%40${userDisplayName}`]);
    },
  });

  return (
    <>
      <Popover className="relative">
        {() => {
          return (
            <div>
              <Popover.Button className="select-none appearance-none inline-flex items-center no-underline border-2 text-[18px] leading-[22px] rounded-full shadow-[0_4px_0_0_transparent] shadow-primary endemic:shadow-invert bg-primary text-primary endemic:text-invert border-primary endemic:border-invert px-4 py-1.5 transition-all -translate-y-1 cursor-pointer active:!shadow-transparent active:!translate-y-0 active:bg-yellow md:hover:bg-yellow md:night:hover:bg-red outline-none">
                <BrushIcon className="w-6 h-6 mr-2" /> Open to
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 translate-y-1"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 translate-y-1"
              >
                <Popover.Panel className="absolute z-20 mt-3 w-[310px] p-4 bg-white border-2 border-primary rounded-[20px] -ml-20 lg:ml-0">
                  {({ close }) => (
                    <div>
                      <div className="cursor-pointer flex">
                        <div
                          className="endemic:text-invert"
                          onClick={() => {
                            updateOpenToWorkStatus(!isOpenToWork);
                            close();
                          }}
                        >
                          <h4 className="mb-1">Art orders</h4>
                          <div className="text-body-4">
                            Announce your availability to take on personalized
                            art commissions and grow your client base.
                          </div>
                        </div>
                        <div className="flex items-center pl-2">
                          <div className="w-12">
                            {isOpenToWork && (
                              <CheckIcon className="w-5 h-5 fill-green m-auto" />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Popover.Panel>
              </Transition>
            </div>
          );
        }}
      </Popover>
    </>
  );
};

export default OpenToButton;
